<template>
  <div class="car__number__container">
    <div @click="clickMask()" v-if="visible" class="mask__container" :style="{backgroundColor: maskBackground}"></div>

    <!-- 输入框 -->
    <div @click="open()" ref="inputContainer">
      <slot :value="inputValue">
        <!-- <div
          class="input__container"
          :style="{border: `1px solid ${borderColor}`, borderRadius: borderRadius + 'px', width: width + 'px', height: height + 'px', backgroundColor: backgroundColor}"
        > -->
        <div
          class="input__container"
        >
          <div
            class="input__box"
            v-for="item in carNumberLength"
            :key="item"
            :style="{fontSize: fontSize + 'rem', color: fontColor}"
          >
          <!-- <div class="line" v-if="item != carNumberLength" :style="{backgroundColor: borderColor}"></div> -->
            <span v-if="item == 1 && !inputValue[0]" style="color: #C8C8C8">省</span>
            {{ inputValue[item - 1] }}
          </div>
        </div>
      </slot>
    </div>
    <!-- 键盘 -->
    <transition name="keyboard">
      <div v-if="visible" class="keyboard__container">
        <header class="keybord__header">
          <!-- <span @click.stop="cancel()">清空</span> -->
          <span @click.stop="submit()" style="color: #3399FF">完成</span>
        </header>

        <div class="keyboard__body">
          <ul class="keyboard__body__province__list" v-if="keybordType === 'ABC'">
            <li
              @click.stop="inputWord(item)"
              class="button"
              v-for="item in provinceList.slice(0, 30)"
              :key="item"
            >
              {{ item }}
            </li>
          </ul>
          <div v-else>
            <ul class="keyboard__body__letter__list">
              <li
                @click.stop="inputWord(item, '1')"
                class="button"
                :class="{'numberKey': !inputValue[1]}"
                v-for="item in letterList.slice(0, 10)"
                :key="item"
              >
                {{ item }}
              </li>
            </ul>
            <ul class="keyboard__body__letterKey">
              <li
                @click.stop="inputWord(item)"
                class="button"
                v-for="item in letterList.slice(10, 18)"
                :key="item"
              >
                {{ item }}
              </li>
            </ul>
            <ul class="keyboard__body__letter__list__surplus">
              <li
                @click.stop="inputWord(item)"
                class="button"
                v-for="item in letterList.slice(18, 27)"
                :key="item"
              >
                {{ item }}
              </li>
            </ul>
          </div>

          <div class="keyboard__body__bottom">
            <!-- <div @click.stop="toggle()" class="other__button">
              {{ keybordType }}
            </div> -->
            <ul class="keyboard__body__bottom__item__list" :style="{columnCount: keybordType === 'ABC' ? 7 : 7}">
              <li @click.stop="inputWord(item)" class="button" v-for="item in surplusList" :key="item">
                {{ item }}
              </li>
            </ul>
            <div @click.stop="deleteOne()" class="other__button">
              <!-- 删除 -->
              <img src="@/assets/img/ticket/delete.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'CarNumber',
  props: {
    // 输入框宽度
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 30
    },
    // 输入框边框颜色
    borderColor: {
      type: String,
      default: '#959595'
    },
    // 输入框背景颜色
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    // 边框圆角
    borderRadius: {
      type: Number,
      default: 0
    },
    // 文字颜色
    fontColor: {
      type: String,
      default: '#383838'
    },
    // 文字大小
    fontSize: {
      type: Number,
      default: 0.48
    },
    // 默认车牌号
    defaultCarPlate: {
      type: String
    },
    // 遮罩颜色
    maskBackground: {
      type: String,
      default: 'transparent'
    },
    // 是否点击遮罩关闭键盘
    clickMaskCloseKeyBoard: {
      type: Boolean,
      default: true
    },
    // 是否新能源车牌
    isNewEnergy: {
      type: Boolean,
      default: false
    },
    inputValue: {
      type: Array,
      default: () => [],
    }
  },
  data () {
    return {
      visible: false,
      // inputValue: [],
      carNumberLength: 7,
      keybordType: 'ABC',
      placehoderDom: null,
      isOcclusion: false,
      provinceList: ['京','津','渝','沪','冀','晋','辽','吉','黑','苏','浙','皖','闽','赣','鲁','豫','鄂','湘','粤','琼','川','贵','云','陕','甘','青','蒙','桂','宁','新','藏','使','领','警','学','港','澳'],
      letterList: [1,2,3,4,5,6,7,8,9,0,'Q','W','E','R','T','Y','U','P','A','S','D','F','G','H','J','K','L','Z','X','C','V','B','N','M']
    }
  },
  watch: {
    isNewEnergy: {
      handler (val) {
        this.carNumberLength = val ? 8 : 7
      },
      immediate: true
    },
    defaultCarPlate: {
      handler (val) {
        if (val) {
          this.inputValue = []
          for (let i = 0, len = val.length; i < len; i++) {
            this.inputValue.push(val[i])
          }
        }
      },
      immediate: true
    },
    inputValue: {
      handler () {
        let len = this.isNewEnergy ? 8 : 7
        if (this.inputValue.length === 0) this.keybordType = 'ABC'
        if (this.inputValue.length > 0 && this.inputValue.length < len) this.keybordType = '返回'
      },
      immediate: true
    },
    visible (val) {
      if (val) {
        // 输入框被挡住,同时页面无滚动条时，展示占位块，让页面可滚动
        if (this.checkOcclusion()) {
          this.placehoderDom.style.display = 'block'
        }
        // 只有输入框被挡住的时候才滚动
        if (this.isOcclusion) {
          window.scrollTo(0, 250)
        }
      } else {
        if (this.isOcclusion) {
          document.body.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          })
        }
        this.placehoderDom.style.display = 'none'
      }
    }
  },
  computed: {
    surplusList () {
      if (this.keybordType === 'ABC') {
        return this.provinceList.slice(30, 37)
      } else {
        return this.letterList.slice(27, 34)
      }
    }
  },
  created () {
    if (window !== 'undefined') {
      this.placehoderDom = document.createElement('div')
      this.placehoderDom.style.cssText = 'height: 260px; width: 100%; background: red; opacity: 0'
      this.placehoderDom.style.display = 'none'
      document.body.appendChild(this.placehoderDom)
    } else {
      throw new Error('不支持非window环境')
    }
  },
  methods: {
    // 关闭键盘
    close () {
      this.visible = false
    },
    // 打开键盘
    open () {
      this.visible = true
    },
    // 清空
    cancel () {
      this.inputValue = []
      this.$emit('submit', this.inputValue.join(''))
    },
    // 完成输入
    submit () {
      this.$emit('submit', this.inputValue.join(''))
      console.log(this.inputValue);
      this.close()
    },
    // 键盘类型切换
    toggle () {
      let len = this.isNewEnergy ? 7 : 6
      if (this.inputValue.length > 0 && this.inputValue.length < len) return
      this.keybordType = this.keybordType === 'ABC' ? '返回' : 'ABC'
    },
    // 删除一个字符
    deleteOne () {
      this.inputValue.pop()
    },
    // 输入
    inputWord (val, type) {
      if(type === '1' && this.inputValue.length === 1){
        return
      }
      if (this.isNewEnergy) {
        if (this.inputValue.length === 8) return
      } else {
        if (this.inputValue.length === 7) return
      }
      this.inputValue.push(val)
    },
    // 检测键盘是否遮挡输入框
    checkOcclusion () {
      const clientHeight = document.documentElement.clientHeight
      const scrollHeight = document.documentElement.scrollHeight
      const inputTopHeight = this.$refs.inputContainer.getBoundingClientRect().top
      const inputHeight = this.$refs.inputContainer.scrollHeight
      // 键盘是否挡住输入框
      this.isOcclusion = inputHeight + 250 + inputTopHeight >= clientHeight
      // 如果输入框被挡住，并且页面没有滚动条,返回true
      if (
        inputHeight + 250 + inputTopHeight >= clientHeight &&
        scrollHeight === clientHeight
      ) {
        return true
      } else {
        return false
      }
    },
    clickMask () {
      if (this.clickMaskCloseKeyBoard) {
        this.submit()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.car__number__container {
  user-select: none;
  font-size: 0.32rem;
  .keyboard-enter-active,
  .keyboard-leave-active {
    transition: all 0.2s linear;
    transform: translateY(0px);
  }
  .keyboard-enter, .keyboard-leave-to {
    transform: translateY(250px);
}
  .mask__container {
    width: 100vw;
    overflow-y: scroll;
    height: calc(100vh + 250px);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
  }
  .input__container {
    // position: relative;
    // z-index: 99;
    display: flex;
    justify-content: space-between;
    // margin: 0 0.25rem;
    .input__box {
      // flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e6e6e6;
      width: 0.7rem;
      height: 1rem;
      border-radius: 0.08rem;
      background: #F5F5F5;
      // position: relative;
    }
    .line {
      width: 1px;
      position: absolute;
      transform: translate(0, -50%);
      top: 50%;
      right: 0;
      height: 50%;
    }
  }
  
  .keyboard__container {
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 250px;
    // background: #d0d3dc;
    // box-shadow: 0 6px 10px 3px #959595;
    background: #f0f0f0;
    .keybord__header {
      padding: 0 0.3rem;
      // height: 40px;
      // line-height: 40px;
      height: 0.7rem;
      line-height: 0.7rem;
      display: flex;
      // justify-content: space-between;
      justify-content: flex-end;
      background: rgb(240, 240, 240);
    }
    .keyboard__body {
      padding: 5px 5px 15px 5px;
      box-sizing: border-box;
      &__province__list {
        list-style: none;
        padding: 0;
        margin: 0;
        column-count: 10;
        column-gap: 5px;
      }
      &__letter__list {
        list-style: none;
        padding: 0;
        margin: 0;
        column-count: 10;
        column-gap: 5px;
      }
      &__letterKey{
        list-style: none;
        padding: 0;
        margin: 0;
        column-count: 8;
        column-gap: 5px;
      }
      &__letter__list__surplus {
        list-style: none;
        padding: 0;
        margin: 0;
        column-count: 9;
        column-gap: 5px;
        padding: 0 13px;
      }
      &__bottom {
        // width: 96vw;
        padding: 0 0.3rem;
        display: flex;
        justify-content: space-between;
        &__item__list {
          width: 100%;
          margin: 0;
          padding: 0 5px;
          list-style: none;
          column-count: 7;
          column-gap: 5px;
        }
      }
    }
  }
  .button {
    &:active {
      background: rgb(240, 237, 237);
    }
    text-align: center;
    line-height: 40px;
    height: 40px;
    border-radius: 5px;
    background: white;
    color: black;
    margin-bottom: 7px;
  }
  .numberKey{
    color: #C8C8C8;
  }
  .other__button {
    &:active {
      background: white;
    }
    width: 25vw;
    height: 40px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    color: #000;
    img{
      width: 1rem;
    }
    .delete__btn {
      font-size: 14px;
      color: #fff;
      background: #000;
      width: 0.3rem;
      height: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>